export function getDayNamesKeys(): string[] {
  const dayNames = [];
  for (let i = 0; i < 7; i++) {
    const dt = new Date(Date.UTC(2023, 0, 1 + i));
    const dayName = dt.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });
    dayNames.push(`t.${dayName}`.toLowerCase());
  }
  return dayNames;
}
